// share
(function(){
    $('body').append('<div id="share-list"><ul><li class="tw"><img src="/images/style/twitter.svg" alt="Twitter"></li><li class="reddit"><img src="/images/style/reddit.svg" alt="Reddit"></li><li class="ln"><img src="/images/style/linkedin.svg" alt="Linkedin"></li><li class="gmail"><img src="/images/style/gmail.svg" alt="Gmail"></li><li class="whatsapp"><img src="/images/style/whatsapp.svg" alt="Whatsapp"></li></ul></div>');
    var nowh=window.location.href;
    var head=$($("h1")[0]).html().replace('%','%25');
    $('#share-list li.fb').click(function(){
        window.open("https://www.facebook.com/sharer.php?u="+nowh);
    })
    $('#share-list li.tw').click(function(){
        window.open("https://twitter.com/intent/tweet?text="+head+" "+nowh);
    })
    $('#share-list li.ln').click(function(){
        window.open("https://www.linkedin.com/shareArticle?mini=true&url="+nowh+"&title="+document.title);
    })
    $('#share-list li.gmail').click(function(){
        window.open("https://mail.google.com/mail/u/0/?view=cm&fs=1&to&su="+document.title.replace('%','%25')+"&body="+nowh+"&ui=2&tf=1");
    })
    $('#share-list li.reddit').click(function(){
        window.open("https://www.reddit.com/submit?url="+nowh+"&title="+document.title);
    })
    $('#share-list li.whatsapp').click(function(){
        window.open("https://api.whatsapp.com/send?text="+document.title+"%20"+nowh);
    })
})();